import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { getBlogPost } from "../services/api";
import NotFound from "../pages/NotFound";

const LEGACY_MAP = {
  "/privacy-policy": "/datenschutz",
  "/payment": "/agb",
  "/shipping-and-returns": "/agb",
  "/store-categories": "/store",
  "/shop": "/store",
  "/cart": "/store",
  "/legal-notice": "/impressum",
  "/label": "/label-designer",
  "/process": "/how-it-works",
  "/wine-regions": "/regions",
  "/wine-producers": "/producers",
  "/my-account": "/account",
  "/blank": "/",
  "/wine-store": "/store",
};

// Old WP URL patterns by first path segment
const PREFIX_MAP = {
  "product-category": "/store",
  "store-categories": "/store",
  "category": "/store",
  "produkt": "/store",
  "tag": "/blog",
  "author": "/blog",
};

export default function LegacyRedirect() {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    setNotFound(false);
    const path = ("/" + pathname.replace(/^\/+|\/+$/g, "")).toLowerCase();
    if (LEGACY_MAP[path]) {
      navigate(LEGACY_MAP[path], { replace: true });
      return;
    }
    const segments = path.split("/").filter(Boolean);
    const first = segments[0] || "";
    if (first.startsWith("wp-") || segments.includes("feed")) {
      setNotFound(true);
      return;
    }
    if (PREFIX_MAP[first]) {
      navigate(PREFIX_MAP[first], { replace: true });
      return;
    }
    if (segments.length === 1) {
      getBlogPost(segments[0])
        .then(() => navigate(`/blog/${segments[0]}`, { replace: true }))
        .catch(() => setNotFound(true));
    } else {
      setNotFound(true);
    }
  }, [pathname, navigate]);

  return notFound ? <NotFound /> : null;
}
